import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'svg-tt-sprite',
  templateUrl: './svg-tt.component.html',
  styleUrls: ['./svg-tt.component.scss']
})
export class SvgTtComponent implements OnInit {
  data: any;
  constructor() { }

  ngOnInit() {
  }

}
